// Library components
import { message } from 'antd';

// Default values
const defaultDuration = 4;

export default {
  error(text, onClose, duration = defaultDuration, key = '') {
    message.error({
      content: text, duration, onClose, key,
    });
  },
  info(text, onClose, duration = defaultDuration, key = '') {
    message.info({
      content: text, duration, onClose, key,
    });
  },
  success(text, onClose, duration = defaultDuration, key = '') {
    message.success({
      content: text, duration, onClose, key,
    });
  },
  warning(text, onClose, duration = defaultDuration, key = '') {
    message.warning({
      content: text, duration, onClose, key,
    });
  },
};
